<template>
	<div class="drug-list">
		<p v-if="list.length == 0" class="font-weight-thin ml-2" v-translate>No drugs selected.</p>
		<v-list v-else flat>
			<div
				v-infinite-scroll="loadMore"
				infinite-scroll-disabled="loading"
				infinite-scroll-distance="0"
				v-if="infiniteScroll">
				<DrugItem
					v-for="drug in list"
					:drug="drug"
					:context="context"
					:key="drug.id"
					@remove-drug="removeDrug(drug)"
					@edit-drug="editDrug(drug)"
					:drugInteractions="drugInteractions"
					:disabled="disabled"
					:editable="editable"
				/>
				<v-row class="mt-2" v-if="loading" no-gutters>
					<v-progress-linear
            :active="loading"
            :indeterminate="loading"
            top
            color="primary"
          ></v-progress-linear>
				</v-row>
			</div>
			<DrugItem
				v-else
				v-for="drug in list"
				:drug="drug"
				:context="context"
				:key="drug.id"
				@remove-drug="removeDrug(drug)"
				@edit-drug="editDrug(drug)"
				:drugInteractions="drugInteractions"
				:disabled="disabled"
				:editable="editable"
			/>
		</v-list>
	</div>
</template>

<script>
import DrugItem from "@/components/drugs/DrugItem.vue";
import infiniteScroll from "vue-infinite-scroll";

export default {
	name: "DrugList",
	components: {
		DrugItem
	},
	directives: {
		infiniteScroll
	},
	props: {
		list: {},
		editable: {
			default: true
		},
		context: {},
		drugInteractions: {},
		disabled: {
			default: false
		},
		infiniteScroll: {
			default: false
		}
	},
	data:() => ({
		loading: false,
		over: false
	}),
	methods: {
		loadMore() {
			if(!this.over) {
				this.loading = true;
				console.log("load more");
				this.$emit('load-more');
			}
		},
		addDrugs(drugs) {
			this.loading = false;
			if(drugs.length == 0) this.over = true;
			for(let i = 0; i < drugs.length; i++) {
        this.list.push(drugs[i]);
			}
		},
		removeDrug: function(drug) {
			this.$emit("remove-drug", drug);
		},
		editDrug: function(drug) {
			this.$emit("edit-drug", drug);
		},
		showDetails: function(drug) {
			console.log(drug);
		}
	}
};
</script>